import { makePostCall } from 'frontend/core/src/data/util';
import { hostUrl } from 'frontend/core/src/utils/getServerUrl';

export {
  UpdatePasswordQuery,
  DeleteAccountCleanupQuery,
  DeleteAccountQuery,
  AddUserAttributeQuery,
  DeleteUserAttributeQuery
} from '@prophecy/queries/pages/UserSettings/queries/profile';

const DeleteUserAccountAPI = '/api/deleteUser';
export const deleteUserAccount = async () => {
  return await makePostCall(hostUrl + DeleteUserAccountAPI, {});
};
